import "./Administracion.css";
import React, { useState, useEffect, useRef } from "react";

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import moment from "moment";
import { formatMoneda } from "../../util/varios";
import { ActualizarTransferencias } from "./modalActualizarTransferencias";
import { PrimaryButton } from "../../ui/buttons/Button";
import { Input } from "../../ui/inputs/Input";

const TablaTransferenciasBancarias = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "OBSERVACIÓN",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "MONTO",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob, setAprob] = useState(null);
  const [transferencia, setTransferencia] = useState();
  const [movimientos, setMovimientos] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idtransferenciabancaria.includes(target.value) ||
              x.observaciones
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.monto.toString().replace(",", "").replace(".", ","),
                ",",
                ".",
                2,
              ).includes(target.value) ||
              moment
                .utc(x.fechareal)
                .format("DD-MM-YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };
  const seleccionarRegistros = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/administracion/registrostransferenciasbancarias?idfiscal=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
          } else {
            setRecords([]);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarTransferencia = (id) => {
    let campos = "*";
    let nomtab = "transferenciabancaria";
    let nomid = "idtransferenciabancaria";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtransferenciabancaria > 0) {
            setTransferencia(response.data);
            seleccionarMovimientos(id);
          } else {
            setTransferencia();
            seleccionarMovimientos(id);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const seleccionarMovimientos = (id) => {
    let endpoint = `${op.conexion}/api/administracion/movimientos?id=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            let datos = [];
            let cuentaorigen;
            let cuentadestino;
            let idmovorigen;
            let idmovdestino;
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].tipo === 16) {
                cuentaorigen = response.data[i].idcuentabancaria;
                idmovorigen = response.data[i].idmovimientobancario;
              } else if (response.data[i].tipo === 17) {
                cuentadestino = response.data[i].idcuentabancaria;
                idmovdestino = response.data[i].idmovimientobancario;
              }
            }
            datos.push({
              idcuentaorigen: cuentaorigen,
              idcuentadestino: cuentadestino,
              idmoviorigen: idmovorigen,
              idmovidestino: idmovdestino,
            });

            setMovimientos(datos);
            setMostrar2(true);
          } else {
            setMovimientos();
            setMostrar2(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };
  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionar = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);
      seleccionarTransferencia(data.idtransferenciabancaria);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);
      seleccionarTransferencia(data.idtransferenciabancaria);
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <div className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant">
        <h3 className="m-0">Transferencias Bancarias</h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fa fa-times ms-2"></i>
        </a>
      </div>
      <div className="col-12 m-0 p-2 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
            className="search-input form-control form-control-sm"
          />
        </div>
        <PrimaryButton
          onClick={gestionar(1, "")}
          icon="fa-plus m-0"
        ></PrimaryButton>
      </div>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {item.idtransferenciabancaria}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "300px",
                    }}
                  >
                    {item.observaciones}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {formatMoneda(
                      item.monto.toString().replace(",", "").replace(".", ","),
                      ",",
                      ".",
                      2,
                    )}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {moment.utc(item.fechareal).format("DD-MM-YYYY")}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={gestionar(4, item)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      onClick={gestionar(2, item)}
                      className="btn btn-sm mx-1 btn-success rounded-pill"
                    >
                      <i className="fas fa-sync-alt"></i> Reversar
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ActualizarTransferencias
        show={mostrar2}
        operacion={operacion}
        aprobado={aprob}
        ubi={44}
        tip={0}
        transferencia={transferencia}
        movimientos={movimientos}
        titulo={
          operacion === 4
            ? "Orden Pago Devuelto"
            : "Devolver Orden de Pago a Administración"
        }
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaTransferenciasBancarias;
